// The brand's library lists in the query cache. A save from a job (generation) and every library
// change (library) read them again through this one function, since features do not import each
// other.
import type { QueryClient } from "@tanstack/react-query";

import { getGetTrashQueryKey, getListAssetsQueryKey } from "./generated/endpoints/assets/assets";
import { refreshTeamStorage } from "./team-storage";

/**
 * Reads every list of the brand's library again: each filter, the trash and their pages, and the
 * trash's summary (its files and bytes), and the team's storage, which the header's pill shows. A
 * list on screen refetches now; any other is stale, so it refetches when it mounts.
 */
export async function refreshLibraryLists(
  queryClient: QueryClient,
  teamId: string,
  brandId: string,
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: [getListAssetsQueryKey(teamId, brandId)[0]] }),
    queryClient.invalidateQueries({ queryKey: getGetTrashQueryKey(teamId, brandId) }),
    refreshTeamStorage(queryClient, teamId),
  ]);
}
